import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import store from '../../store';
import {
	solarActivityLevelOptions,
	solarShadowLevelOptions,
} from '../solarSectionConfig';
import {
	selectSolarActivityLevel, selectSolarActivityLevelIsSatisfied,
	selectSolarDimmProfile, selectSolarDimmProfileIsSatisfied,
	selectSolarShadowLevel,
	selectSolarShadowLevelIsSatisfied, selectSolarVersion
} from '../solarSelectors';
import {solarDimmProfileOptions} from '../dimProfiles';

@customElement('solar-settings-panel')
export class SolarSettingsPanel extends connect(store)(LitElement) {

	static styles = css`
		:host {
			width: 350px;
		}

		.solarSettingsPanel {
			display: flex;
			flex-direction: column;
			gap: var(--padding);
			margin-bottom: 120px;
		}
	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	dimmProfileCanBeSelected(state, id) {
		const version = selectSolarVersion(state);
		return version === 'AetoPro' || version === 'AetoBasic' && ['profile3', 'profile4', 'profile5'].includes(id);
	}

	activityLevelCanBeSelected(state, id) {
		const dimmProfile = selectSolarDimmProfile(state);
		if (['profile0', 'profile1', 'profile2'].includes(dimmProfile)) {
			return true;
		} else if (['profile3', 'profile4', 'profile5'].includes(dimmProfile)) {
			return id === 'none';
		} else {
			return id !== 'none';
		}
	}

	stateChanged(state) {
		this.state = state;
		this.translations = state.productData.translations;
		this.productData = state.productData.productData;
		this.region = state.status.region;
		this.lang = state.status.lang;
		this.loggedIn = state.userProfile.data.loggedIn;
	}

	render() {
		return html`
			<div class="solarSettingsPanel">
				<list-select
					.title=${{
						de: 'Dimmprofil',
						en: 'Dimmprofile',
						fr: 'Profil de gradation'
					}}
					.noWrap=${true}
					.options=${solarDimmProfileOptions}
					action='solar/setSolarDimmProfile'
					.selected=${selectSolarDimmProfile}
					.canBeSelected=${this.dimmProfileCanBeSelected}
					.isSatisfied=${selectSolarDimmProfileIsSatisfied}></list-select>
				<list-select
					.title=${{
						de: 'Bewegungsmelder',
						en: 'Motion Sensor',
						fr: 'Détecteur de mouvement'
					}}
					.noWrap=${true}
					.options=${solarActivityLevelOptions}
					action='solar/setSolarActivityLevel'
					.selected=${selectSolarActivityLevel}
					.canBeSelected=${this.activityLevelCanBeSelected}
					.isSatisfied=${selectSolarActivityLevelIsSatisfied}></list-select>
				${when(this.loggedIn, () => html`
					<list-select
						.title=${{
							de: 'Verschattung',
							en: 'Shading',
							fr: 'Ombrage'
						}}
						.options=${solarShadowLevelOptions}
						action='solar/setSolarShadowLevel'
						.selected=${selectSolarShadowLevel}
						.canBeSelected=${() => true}
						.isSatisfied=${selectSolarShadowLevelIsSatisfied}>
					</list-select>`)}
				<spc-attribute .attributeId=${{localId: 'LE_ColourTemperature_1'}} .hideDisabled=${true}></spc-attribute>
				<spc-attribute .attributeId=${{localId: 'LU_Battery'}} .hideDisabled=${true}></spc-attribute>
				<spc-attribute .attributeId=${{localId: 'HS_Construction'}} .hideDisabled=${true}></spc-attribute>
				<spc-attribute .attributeId=${{localId: 'HS_HousingSize'}} .hideDisabled=${true}></spc-attribute>
				<self-sufficiency></self-sufficiency>
			</div>
		`;
	}
}
